import { useAppStore } from '../store/useAppStore';
import { translations } from '../utils/translations';

export const useTranslations = () => {
  const { language } = useAppStore();
  
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };
  
  return { t, language };
};
